import * as ApiTypes from './ApiTypes';
import { IBpsReferenzkraftRolleMessung } from './ApiTypesBps2021';
import { IDmgKalibrierungMesspunkt, IDmgKalibrierungDatensatz } from './ApiTypesDmg';
import { IBpsReferenzkraftMessungPlatte, IBpsReferenzkraftPlattensatzMesspunkt } from './ApiTypesBpsPlatte';
import { IAgtPartikelzaehlerMessung, IAgtPartikelzaehlerMessreihe } from './ApiTypesAgtPartikelzaehler';

/** "Factory" zum Vorbelegen von Datenstrukturen */

export const leereAdresse = (): ApiTypes.IAdresse => ({
  adressid: undefined,
  name: '',
  zusatz: '',
  strasse: '',
  plz: '',
  tel1: '',
  bundesland: '',
  ort: '',
  untersuchungsstellenkennung: '',
  email: '',
  email2: ''
});

/** Datensatz mit vorbelegten Werten für die Kalibrierung von Rollenbremsprüfstanden nach 2021er Rili */
export const leererDatensatzBPSReferenzkraftRili2021 = (): IBpsReferenzkraftRolleMessung => ({
  version: 2,
  richtlinie: '2021',
  rollendurchmesser: {
    messwerte: [
      /*links vorne*/
      [null, null, null],
      /*links hinten*/
      [null, null, null],
      /*rechts vorne*/
      [null, null, null],
      /*rechts hinten*/
      [null, null, null]
    ],
    mittelwert: {
      links: null,
      rechts: null
    },
    faktor: {
      links: null,
      rechts: null
    },
    grunddurchmesser: undefined
  },
  oberflaeche: 'beschichtet',
  messart: 'durchmesser',
  messbereich: undefined,
  messbereichKlein: undefined,
  messbereichGross: undefined,
  anzeige: undefined,
  justageInfo: 'keine',
  rollensatz: {
    links: {
      position: 'links',
      messpunkte: [],
      vorbelastung: {
        messpunkte: [
          { anzeige: null, normal: null },
          { anzeige: null, normal: null }
        ]
      }
    },
    rechts: {
      position: 'rechts',
      messpunkte: [],
      vorbelastung: {
        messpunkte: [
          { anzeige: null, normal: null },
          { anzeige: null, normal: null }
        ]
      }
    }
  },
  rollensatzJustage: {
    links: {
      position: 'links',
      messpunkte: [],
      vorbelastung: {
        messpunkte: [
          { anzeige: null, normal: null },
          { anzeige: null, normal: null }
        ]
      }
    },
    rechts: {
      position: 'rechts',
      messpunkte: [],
      vorbelastung: {
        messpunkte: [
          { anzeige: null, normal: null },
          { anzeige: null, normal: null }
        ]
      }
    },
    gesamtErgebnis: []
  },
  pruefortparameter: {
    beginn: {
      luftfeuchtigkeit: {
        wert: null,
        min: 0,
        max: 85
      },
      lufttemperatur: {
        wert: null,
        min: 5,
        max: 35
      }
    },
    ende: {
      luftfeuchtigkeit: {
        wert: null,
        min: 0,
        max: 85
      },
      lufttemperatur: {
        wert: null,
        min: 5,
        max: 35
      }
    }
  },
  gesamtErgebnis: [],
  waegezelle: {
    messwerte: [undefined, undefined, undefined],
    sollwert: 49,
    toleranz: 1
  },
  drehzahlschlupf: {
    links: {
      geschwindigkeit: [undefined, undefined],
      schlupf: null
    },
    rechts: {
      geschwindigkeit: [undefined, undefined],
      schlupf: null
    },
    mingeschwindigkeit: 2,
    maxschlupf: 30
  },
  kmg: '',
  objekt: ''
});

export const leererBPSMesspunktPlatte = (): IBpsReferenzkraftPlattensatzMesspunkt => ({
  anzeige: 0,
  mittelwert: undefined,
  mittelwertabweichung: null,
  messunsicherheit: null,
  beurteilung: null,
  messwerte: [
    { bps: 0, sensor: null, referenzwert: null, messwertabweichung: null},
    { bps: 0, sensor: null, referenzwert: null, messwertabweichung: null},
    { bps: 0, sensor: null, referenzwert: null, messwertabweichung: null}
  ]
});

/** Datensatz mit vorbelegten Werten für die Kalibrierung von Rollenbremsprüfstanden nach 2021er Rili */
export const leererDatensatzBPSReferenzkraftPlatte = (): IBpsReferenzkraftMessungPlatte => ({
  version: 1,
  richtlinie: '2021',
  messbereich: undefined,
  anzeige: undefined,
  justageInfo: 'keine',
  plattensatz: {
    links: {
      position: 'links',
      messpunkte: [],
      vorbelastung: {
        messpunkte: [
          { anzeige: null, normal: null },
          { anzeige: null, normal: null }
        ]
      }
    },
    rechts: {
      position: 'rechts',
      messpunkte: [],
      vorbelastung: {
        messpunkte: [
          { anzeige: null, normal: null },
          { anzeige: null, normal: null }
        ]
      }
    }
  },
  plattensatzJustage: {
    links: {
      position: 'links',
      messpunkte: [],
      vorbelastung: {
        messpunkte: [
          { anzeige: null, normal: null },
          { anzeige: null, normal: null }
        ]
      }
    },
    rechts: {
      position: 'rechts',
      messpunkte: [],
      vorbelastung: {
        messpunkte: [
          { anzeige: null, normal: null },
          { anzeige: null, normal: null }
        ]
      }
    },
    gesamtErgebnis: []
  },
  pruefortparameter: {
    beginn: {
      lufttemperatur: {
        wert: null,
        min: 5,
        max: 35
      }
    },
    ende: {
      lufttemperatur: {
        wert: null,
        min: 5,
        max: 35
      }
    }
  },
  waegezelle: {
    messwerte: [undefined, undefined, undefined],
    sollwert: 49,
    toleranz: 1
  },
  gesamtErgebnis: [],
  kmg: '',
  objekt: ''
});

export const leererDmgMesspunkt = (): IDmgKalibrierungMesspunkt => ({
  index: 0,
  nenndruck: 0,
  m1: {
    normal: null,
    anzeige: null
  },
  m2: {
    normal: null,
    anzeige: null
  }
});

export const leererDatensatzDmgKalibrierung = (): IDmgKalibrierungDatensatz => ({
  version: 1,
  messpunkte: [],
  haltezeiteingehalten: false,
  vorbelastungbisendwert: false,
  zeigerart: '',
  kalibrierbereich: {
    von: null,
    bis: null
  },
  pruefortparameter: {
    beginn: {
      lufttemperatur: {
        wert: null,
        min: 18,
        max: 28
      },
      luftfeuchtigkeit: {
        wert: null,
        min: 25,
        max: 65
      }
    },
    ende : {
      lufttemperatur: {
        wert: null,
        min: 18,
        max: 28
      },
      luftfeuchtigkeit: {
        wert: null,
        min: 25,
        max: 65
      }
    }
  }
});

export const leereMessreiheAgtPartikelzaehler = (nennwert: number): IAgtPartikelzaehlerMessreihe => ({
  nennwert: nennwert,
  partikelgroesse: [
    { zeitpunkt: 0, einheit: 's', wert: null},
    { zeitpunkt: 20, einheit: 's', wert: null}
  ],
  anzeigenormal: [
    { zeitpunkt: 0, einheit: '#/cm³', wert: null},
    { zeitpunkt: 20, einheit: '#/cm³', wert: null}
  ],
  anzeigegeraet: [
    { zeitpunkt: 0, einheit: '#/cm³', wert: null},
    { zeitpunkt: 5, einheit: '#/cm³', wert: null},
    { zeitpunkt: 10, einheit: '#/cm³', wert: null},
    { zeitpunkt: 15, einheit: '#/cm³', wert: null},
    { zeitpunkt: 20, einheit: '#/cm³', wert: null}
  ],
  beurteilung: null
});

export const leererDatensatzAgtPartikelzaehlerMessung = (): IAgtPartikelzaehlerMessung => ({
  version: 1,
  justage: false,
  pruefortparameter: {
    beginn: {
      lufttemperatur: {
        wert: null,
        min: 15,
        max: 35
      },
      luftfeuchtigkeit: {
        wert: null,
        min: 25,
        max: 90
      },
      umgebungsdruck: {
        wert: null,
        min: 860,
        max: 1060
      }
    },
    ende : {
      lufttemperatur: {
        wert: null,
        min: 15,
        max: 35
      },
      luftfeuchtigkeit: {
        wert: null,
        min: 25,
        max: 90
      },
      umgebungsdruck: {
        wert: null,
        min: 860,
        max: 1060
      }
    }
  },
  messreihen: [
    leereMessreiheAgtPartikelzaehler(400000),
    leereMessreiheAgtPartikelzaehler(250000),
    leereMessreiheAgtPartikelzaehler(50000)
  ],
  messreihenJustage: [
    leereMessreiheAgtPartikelzaehler(400000),
    leereMessreiheAgtPartikelzaehler(250000),
    leereMessreiheAgtPartikelzaehler(50000)
  ],
  pck: '',
  objekt: ''
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/ApiTypeFactory.ts